<div class="container {{ OBJ_LNG_NAME }} insertEdit">
	<div class="dialog-header">
		<h1 mat-dialog-title>
			{{ (aktuell.id ? 'allgemein.bearbeiten' : 'allgemein.neu') | translate:locale.language:{ typ:
			OBJ_LNG_NAME+'.typ' | translate:locale.language } }}
			<mat-progress-bar *ngIf="dataService.isRequestRunning" color="primary"
				mode="indeterminate"></mat-progress-bar>
		</h1>
		<button class="close-button" mat-icon-button type="button" mat-dialog-close><mat-icon
				aria-label="Schließen">close</mat-icon></button>
	</div>
	<mat-dialog-content>
		<form #inserteditForm="ngForm" class="{{ OBJ_LNG_NAME }} inserteditForm">
			<input matInput [hidden]="true" [(ngModel)]="aktuell.id" name="id" autofocus />
			<input matInput [hidden]="true" [(ngModel)]="aktuell.fragebogenId" name="fragebogenId" />
			<p class="errors" *ngIf="dataService.fehler" [innerHTML]="dataService.fehler.messagehtml"></p>
			<mat-form-field class="full-width">
				<input matInput #fragestellung="ngModel" [(ngModel)]="aktuell.fragestellung" name="name" maxlength="300" [disabled]="dialogrunningajaxcall" required (input)="setSubmit(true)" />
				<mat-label>{{ OBJ_LNG_NAME+'.fragestellung' | translate:locale.language }}</mat-label>
				<mat-hint *ngIf="fragestellung.errors && (fragestellung.dirty || fragestellung.touched) && fragestellung.errors.required">{{'allgemein.validierung.nichtleer' | translate:locale.language:{ typ: OBJ_LNG_NAME+'.name' | translate:locale.language } }}</mat-hint>				<mat-hint *ngIf="fragestellung.value" align="end">{{ fragestellung.value.length }} / 300</mat-hint>
			</mat-form-field>

			<mat-form-field class="full-width">
				<mat-select [(ngModel)]="aktuell.typ" (valueChange)="setSubmit(true)" name="typCtl" class="full-width" [disabled]="dialogrunningajaxcall" required>
					<mat-option *ngFor="let typ of aktuell.typen" [value]="typ">{{ typ }}</mat-option>
				</mat-select>
				<mat-label>{{ OBJ_LNG_NAME+'.fragen-typ' | translate:locale.language }}</mat-label>
			</mat-form-field>

			<mat-form-field class="full-width">
				<mat-select [(ngModel)]="aktuell.elternfrage" (valueChange)="setSubmit(true)"
					[compareWith]="compareMitId" name="elternCtl" class="full-width" [disabled]="dialogrunningajaxcall"
					required>
					<mat-option *ngFor="let ef of elternfragen" [value]="ef" (click)="getElternantworten(ef)">{{ef.fragestellung }}</mat-option>
				</mat-select>
				<mat-label>{{ OBJ_LNG_NAME+'.elternfrage' | translate:locale.language }}</mat-label>
			</mat-form-field>
			<div class="editor-title" *ngIf="aktuell.elternfrage != null && aktuell.elternfrage.id != null">
				{{ OBJ_LNG_NAME+'.antworten' | translate:locale.language }}
			</div>
			<table class="abhang-table" *ngIf="aktuell.elternfrage != null && aktuell.elternfrage.id != null">
				<tr>
					<th class="center">{{ OBJ_LNG_NAME+'.abhaengigkeit' | translate:locale.language }}</th>
					<th class="center">{{ OBJ_LNG_NAME+'.sollGewaehlt' | translate:locale.language }}</th>
					<th class="center">{{ OBJ_LNG_NAME+'.antwort' | translate:locale.language }}</th>
				</tr>
				<tr *ngFor="let ea of elternantworten">
					<td class="center">
						<mat-checkbox [(ngModel)]="ea.selected" [name]="ea.id + 'selected'" (change)="checkElternantwort(ea);setSubmit(true)" color="primary"></mat-checkbox>
					</td>
					<td class="center">
						<mat-slide-toggle color="primary" [name]="ea.id + 'sollGewaehlt'" [id]="ea.id + 'sollGewaehlt'" [disabled]="!ea.selected" [(ngModel)]="ea.sollGewaehlt" (change)="checkElternantwort(ea);setSubmit(true)"></mat-slide-toggle>
					</td>
					<td class="center">{{ ea.text }}</td>
				</tr>
			</table>
			<mat-form-field class="full-width">
				<input matInput #sortierung="ngModel" (input)="setSubmit(true)" [(ngModel)]="aktuell.sortierung"
					type="number" name="sortierung" [min]="1"
					[max]="neu ? aktuell.maxSortierung + 1 : aktuell.maxSortierung" [disabled]="dialogrunningajaxcall"
					required />
				<mat-label>{{ OBJ_LNG_NAME+'.sortierung' | translate:locale.language }}</mat-label>
				<mat-hint
					*ngIf="sortierung.errors && (sortierung.dirty || sortierung.touched) && (sortierung.errors.required || sortierung.errors.min || sortierung.errors.max)">{{
					'allgemein.validierung.nichtleerzwischen' | translate:locale.language:{ typ:
					OBJ_LNG_NAME+'.sortierung' | translate:locale.language, von: '1', bis: (neu ? aktuell.maxSortierung
					+ 1 : aktuell.maxSortierung) } }}</mat-hint>
			</mat-form-field>

		</form>
	</mat-dialog-content>

	<mat-dialog-actions align="end">

		<button mat-raised-button type="button" (click)="close()" [disabled]="dialogrunningajaxcall">{{
			'allgemein.abbrechen' | translate:locale.language }}</button>
		<button mat-raised-button type="submit" (click)="speichernAendern()" color="primary"
			[disabled]="!canSubmit || dialogrunningajaxcall">
			<mat-spinner *ngIf="dialogrunningajaxcall" color="primary" mode="indeterminate"></mat-spinner>
			{{ (dialogrunningajaxcall ? 'allgemein.daten.verarbeiten' : (neu ? 'allgemein.neu' : 'allgemein.speichern'))
			| translate:locale.language:{ typ: OBJ_LNG_NAME+'.liste' | translate:locale.language } }}
		</button>

	</mat-dialog-actions>
</div>